import { render, staticRenderFns } from "./functionalArea.vue?vue&type=template&id=4d5ce498&scoped=true&"
import script from "./functionalArea.vue?vue&type=script&lang=js&"
export * from "./functionalArea.vue?vue&type=script&lang=js&"
import style0 from "./functionalArea.vue?vue&type=style&index=0&id=4d5ce498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5ce498",
  null
  
)

export default component.exports